import Icon from '@passkeys/ui/icon';

import exodus from '@/ui/exodus';
import showSelectChainModal from '@/ui/modals/select-chain-modal';
import Item from './item.js';

function Export() {
  const handleExportClick = async () => {
    const { result: chain } = await showSelectChainModal();
    if (chain) {
      exodus.privateKeys.export({ assetName: chain.name });
    }
  };

  return (
    <Item
      icon="page-key"
      label="Export"
      description="Export private keys to import into other wallets. Never share your private keys with anyone."
      dataTestId="export-settings-item"
      onClick={handleExportClick}
    >
      <Icon
        className="text-black/40 theme-dark:text-neutral-400"
        name="caret-right"
        size={16}
      />
    </Item>
  );
}

export default Export;
